/** ISO country codes used in EnglishTest.UK signup / assessment forms.
 * Subset of most-relevant countries for English test prep candidates.
 * Add more if needed — keep the list short to maintain dropdown UX.
 */
const COUNTRIES = [
  { code: "GB", name: "United Kingdom",  dial: "+44", flag: "🇬🇧" },
  { code: "US", name: "United States",   dial: "+1",  flag: "🇺🇸" },
  { code: "CA", name: "Canada",          dial: "+1",  flag: "🇨🇦" },
  { code: "AU", name: "Australia",       dial: "+61", flag: "🇦🇺" },
  { code: "NZ", name: "New Zealand",     dial: "+64", flag: "🇳🇿" },
  { code: "IE", name: "Ireland",         dial: "+353", flag: "🇮🇪" },
  { code: "IN", name: "India",           dial: "+91", flag: "🇮🇳" },
  { code: "PK", name: "Pakistan",        dial: "+92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh",      dial: "+880", flag: "🇧🇩" },
  { code: "LK", name: "Sri Lanka",       dial: "+94", flag: "🇱🇰" },
  { code: "NP", name: "Nepal",           dial: "+977", flag: "🇳🇵" },
  { code: "CN", name: "China",           dial: "+86", flag: "🇨🇳" },
  { code: "JP", name: "Japan",           dial: "+81", flag: "🇯🇵" },
  { code: "KR", name: "South Korea",     dial: "+82", flag: "🇰🇷" },
  { code: "VN", name: "Vietnam",         dial: "+84", flag: "🇻🇳" },
  { code: "TH", name: "Thailand",        dial: "+66", flag: "🇹🇭" },
  { code: "PH", name: "Philippines",     dial: "+63", flag: "🇵🇭" },
  { code: "ID", name: "Indonesia",       dial: "+62", flag: "🇮🇩" },
  { code: "MY", name: "Malaysia",        dial: "+60", flag: "🇲🇾" },
  { code: "SG", name: "Singapore",       dial: "+65", flag: "🇸🇬" },
  { code: "AE", name: "United Arab Emirates", dial: "+971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia",    dial: "+966", flag: "🇸🇦" },
  { code: "QA", name: "Qatar",           dial: "+974", flag: "🇶🇦" },
  { code: "KW", name: "Kuwait",          dial: "+965", flag: "🇰🇼" },
  { code: "BH", name: "Bahrain",         dial: "+973", flag: "🇧🇭" },
  { code: "OM", name: "Oman",            dial: "+968", flag: "🇴🇲" },
  { code: "JO", name: "Jordan",          dial: "+962", flag: "🇯🇴" },
  { code: "LB", name: "Lebanon",         dial: "+961", flag: "🇱🇧" },
  { code: "EG", name: "Egypt",           dial: "+20", flag: "🇪🇬" },
  { code: "TR", name: "Turkey",          dial: "+90", flag: "🇹🇷" },
  { code: "IR", name: "Iran",            dial: "+98", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq",            dial: "+964", flag: "🇮🇶" },
  { code: "ZA", name: "South Africa",    dial: "+27", flag: "🇿🇦" },
  { code: "NG", name: "Nigeria",         dial: "+234", flag: "🇳🇬" },
  { code: "KE", name: "Kenya",           dial: "+254", flag: "🇰🇪" },
  { code: "GH", name: "Ghana",           dial: "+233", flag: "🇬🇭" },
  { code: "ET", name: "Ethiopia",        dial: "+251", flag: "🇪🇹" },
  { code: "DE", name: "Germany",         dial: "+49", flag: "🇩🇪" },
  { code: "FR", name: "France",          dial: "+33", flag: "🇫🇷" },
  { code: "IT", name: "Italy",           dial: "+39", flag: "🇮🇹" },
  { code: "ES", name: "Spain",           dial: "+34", flag: "🇪🇸" },
  { code: "PT", name: "Portugal",        dial: "+351", flag: "🇵🇹" },
  { code: "NL", name: "Netherlands",     dial: "+31", flag: "🇳🇱" },
  { code: "BE", name: "Belgium",         dial: "+32", flag: "🇧🇪" },
  { code: "CH", name: "Switzerland",     dial: "+41", flag: "🇨🇭" },
  { code: "AT", name: "Austria",         dial: "+43", flag: "🇦🇹" },
  { code: "PL", name: "Poland",          dial: "+48", flag: "🇵🇱" },
  { code: "RU", name: "Russia",          dial: "+7", flag: "🇷🇺" },
  { code: "UA", name: "Ukraine",         dial: "+380", flag: "🇺🇦" },
  { code: "BR", name: "Brazil",          dial: "+55", flag: "🇧🇷" },
  { code: "MX", name: "Mexico",          dial: "+52", flag: "🇲🇽" },
  { code: "AR", name: "Argentina",       dial: "+54", flag: "🇦🇷" },
  { code: "CO", name: "Colombia",        dial: "+57", flag: "🇨🇴" },
  { code: "CL", name: "Chile",           dial: "+56", flag: "🇨🇱" },
];

export default COUNTRIES;
